module.exports = __webpack_public_path__ + "static/colorful-sunset-sunrise-dramatic-sky-above-wooden--FLSXCYZ-50aeab31766b462d4470ee3df5e21a16.jpg";